<template>
    <div id="page-branch-list">
        <div class="vx-card p-6">
            <div class="vx-row">
                <!--                <div class="vx-col md:w-1/4">-->
                <!--                    <div class="vx-row" style=" border-radius: 10px;">-->
                <!--                        <div class="vs-component vs-con-input-label vs-input md:w-full mb-5 ">-->
                <!--                            <div class="vs-con-input" style="margin-left: 20px; margin-right: 20px">-->
                <!--                                <div class="flex items-end mt-6 mb-3">-->
                <!--                                    <feather-icon-->
                <!--                                        icon="ListIcon"-->
                <!--                                        class="mr-2"-->
                <!--                                        svgClasses="w-6 h-6"-->
                <!--                                    />-->
                <!--                                    <span class="leading-none font-medium fsz font-bold">Lịch sử thay đổi địa chỉ</span>-->
                <!--                                </div>-->
                <!--                                <div class="vx-col md:w-full sm:w-auto mt-5">-->
                <!--                                    <vs-input class="w-full" v-model="search" placeholder="Tìm kiếm địa chỉ"-->
                <!--                                              @input="searchEmployeeData"/>-->
                <!--                                </div>-->
                <!--                                <div class="vx-col md:w-full sm:w-auto">-->
                <!--                                    <vs-list>-->
                <!--                                        <div v-if="addressOptions.length > 0">-->
                <!--                                            <VuePerfectScrollbar ref="scrollDialog"-->
                <!--                                                                 class="scroll-area&#45;&#45;nofications-dropdown scroll p-0 mb-4"-->
                <!--                                                                 :settings="settings">-->
                <!--                                                <div class="listEmployeeDiv" :key="index"-->
                <!--                                                     v-for="(item, index) in addressOptions">-->
                <!--                                                    <div class="cursor-pointer vx-row mt-2 mb-2" v-if="item">-->
                <!--                                                        <div-->
                <!--                                                            :class="{'vx-col md:w-full' : item.isUser, 'vx-col w-full' : !item.isUser}"-->
                <!--                                                            @click="getLocationEmployee(item)">-->
                <!--                                                            <feather-icon class="MapPinIcon text-primary"-->
                <!--                                                                          icon="MapPinIcon" svgClasses="w-4 h-4"/>-->
                <!--                                                            <div :class="'listEmployeeMap_' + item.id" id="myDIV"-->
                <!--                                                                 style="overflow: hidden;">-->
                <!--                                                                <div class="vx-col md:full">-->
                <!--                                                                    <span>Tên địa chỉ: </span>-->
                <!--                                                                    <span class="font-medium">-->
                <!--                                                                        {{item.fullAddress}}-->
                <!--                                                                    </span>-->
                <!--                                                                </div>-->
                <!--                                                                <div class="vx-col md:full">-->
                <!--                                                                    <span>Loại địa chỉ: </span>-->
                <!--                                                                    <span class="font-medium">{{ item.name }}</span>-->
                <!--                                                                </div>-->
                <!--                                                                <div class="vx-col md:full"-->
                <!--                                                                     v-if="item.isUser === true && (item.status === 0 || item.status === 1)"-->
                <!--                                                                     style="color: #0fdc75; text-align: left">-->
                <!--                                                                    <span-->
                <!--                                                                        class="mr-5">Địa chỉ này đang được sử dụng</span>-->
                <!--                                                                    <feather-icon icon="Navigation2Icon"-->
                <!--                                                                                  svgClasses="w-4 h-4" class="mt-2"/>-->
                <!--                                                                </div>-->
                <!--                                                            </div>-->
                <!--                                                        </div>-->
                <!--                                                    </div>-->
                <!--                                                </div>-->
                <!--                                            </VuePerfectScrollbar>-->
                <!--                                        </div>-->
                <!--                                        <div class="cursor-pointer vx-row mt-2 mb-2" v-else>-->
                <!--                                            <div class="vx-col w-full text-center">-->
                <!--                                                <span>Không tìm thấy địa chỉ</span>-->
                <!--                                            </div>-->
                <!--                                        </div>-->
                <!--                                    </vs-list>-->
                <!--                                </div>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                    </div>-->
                <!--                </div>-->
                <div class="vx-col md:w-1/2">
                    <div class="flex items-end mb-4">
                        <feather-icon
                            icon="RadioIcon"
                            class="mr-2"
                            svgClasses="w-6 h-6"
                        />
                        <span class="leading-none font-medium fsz font-bold">Chi tiết chấm công từ xa</span>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Nhân viên</label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-user"
                                      v-model="checkinLocation.fullName"
                                      v-validate="'required'" name="name"/>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Loại địa chỉ </label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-map-pin"
                                      v-model="checkinLocation.name"
                                      v-validate="'required'" name="name"/>
                            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Địa chỉ </label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-map"
                                      v-model="checkinLocation.fullAddress"/>
                            <span class="text-danger text-sm">{{ errors.first('expiredDate') }}</span>
                        </div>

                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Ngày bắt đầu</label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-calendar"
                                      v-model="startTime"/>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Ngày kết thúc</label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-calendar"
                                      v-model="endTime"/>
                            <span class="text-danger text-sm">{{ errors.first('name') }}</span>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Ngày tạo</label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-calendar"
                                      v-model="dateCreate"
                                      name="comment"/>
                        </div>
                    </div>

                    <div class="vx-row mt-2" v-if="!canUpdate">
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Người duyệt </label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-user-check"
                                      v-model="checkinLocation.approveEmployeeFullName"/>
                        </div>
                        <div class="vx-col md:w-1/2 w-full mt-2">
                            <label class="vs-input--label">Ngày cập nhật</label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-calendar"
                                      v-model="dateUpdate"
                                      name="comment"/>
                        </div>
                        <div class="vx-col w-full mt-2">
                            <label class="vs-input--label mt-2">Bình luận </label>
                            <vs-input class="w-full"
                                      icon-pack="feather"
                                      icon="icon-message-square"
                                      :disabled="!canUpdate"
                                      v-model="checkinLocation.comment"
                                      name="comment"/>
                        </div>
                    </div>

                    <div class="vx-row mt-2 mb-6">
                        <div :class="{'vx-col md:w-1/2 w-full' : isUpdate, 'vx-col w-full' : !isUpdate}">
                            <label class="vs-input--label">Lý do </label>
                            <vs-input class="w-full"
                                      disabled
                                      icon-pack="feather"
                                      icon="icon-edit"
                                      v-model="checkinLocation.reason"
                                      name="comment"/>
                        </div>
                        <div class='vx-col md:w-1/2 w-full' v-if="canUpdate">
                            <label class="vs-input--label">Bình luận </label>
                            <vs-input class="w-full"
                                      :disabled="!canUpdate"
                                      v-model="checkinLocation.comment"
                                      name="comment"/>
                        </div>
                        <div class="vx-col md:w-1/2 w-full">
                            <label class="vs-input--label">Trạng thái</label>
                            <v-select class=""
                                      :disabled="!canUpdate"
                                      v-model="overtimeStatusModel" :clearable="false"
                                      :options="checkInLocationStatusOptions">
                                <span slot="no-options">{{ $t('vSelect.noRowsToShow') }}</span>
                            </v-select>
                        </div>
                    </div>
                </div>

                <div class="vx-col md:w-1/2">
                    <div class="flex items-end mb-4">
                        <feather-icon
                            icon="MapIcon"
                            class="mr-2"
                            svgClasses="w-6 h-6"
                        />
                        <span class="leading-none font-medium fsz font-bold">Bản đồ vị trí</span>
                    </div>
                    <div class="vx-card p-2">
                        <GmapMap
                            :center="center"
                            :zoom="16"
                            map-type-id="terrain"
                            style="width: 100%; height: 31rem">
                            <GmapMarker
                                :position="{lat: Number(checkinLocation.latitude),lng: Number(checkinLocation.longitude)}"
                                country="vi"/>
                        </GmapMap>
                    </div>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="flex flex-wrap items-center justify-end mb-2 mt-2">
                        <vs-button class="ml-auto mt-2" @click="saveChanges" v-if="canUpdate"
                                   :disabled="!canUpdate">Cập nhật
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning"
                                   onclick="window.history.back()">Quay lại
                        </vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>

import * as lang from 'vuejs-datepicker/src/locale';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select'
import {gmapApi} from 'vue2-google-maps'
import moment from 'moment'
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
    name: "RemoteTimekeepingInfo",
    components: {
        Datepicker,
        vSelect,
        VuePerfectScrollbar,
    },
    data() {
        return {
            settings: {
                maxScrollbarLength: 60,
                wheelSpeed: .30,
                suppressScrollX: true,
            },
            search: "",
            timeSpans: [],
            isUpdate: false,
            userInfo: {},
            checkinLocationOption: [],
            checkinLocation: {},
            languages: lang,
            center: {
                lat: 21.030653,
                lng: 105.847130
            },
            locationMarker: null,

            canUpdate: true,

            //list branch
            organizationBranchOptions: [],

            //employee
            employeeOptions: [],
            selectedEmployeeValue: null,

            //checkinLocation
            checkInLocationStatusOptions: [
                {value: 0, label: 'Chờ'},
                {value: 1, label: 'Đã duyệt'},
                {value: 2, label: 'Từ chối'},
                // {value: 3, label: 'Hủy bỏ'}
            ],
            addressOptions: [],

            //info
            statusCheckInLocation: null,
            organizationBranchId: null,
            employeeId: null,
            timeoutRef: null,
            checkSelectAddress: false,
            listAllEmployeeData: [],
            employeeDataApru: [],
            fullNameEmployee: null,
        }
    },
    computed: {
        overtimeStatusModel: {
            get() {
                let object = this.checkInLocationStatusOptions.find(el => el.value === this.checkinLocation.status);
                return {
                    label: object ? object.label : 'Chưa xác định',
                    value: this.checkinLocation.status
                }
            },
            set(obj) {
                this.checkinLocation.status = obj.value;
            }
        },
        validateForm() {
            return !this.errors.any()
        },

        startTime: {
            get() {
                return moment(this.checkinLocation.startTime).format('DD/MM/YYYY')
            }
        },

        endTime: {
            get() {
                return moment(this.checkinLocation.endTime).format('DD/MM/YYYY')
            }
        },

        dateCreate: {
            get() {
                return moment(this.checkinLocation.createdDate).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        dateUpdate: {
            get() {
                if (this.checkinLocation.status !== 1 && this.checkinLocation.status !== 2) {
                    return ""
                }
                return moment(this.checkinLocation.modifiedDate).format('DD/MM/YYYY HH:mm:ss')
            }
        },

        selectedOrganizationBranch: {
            get() {
                return {
                    label: this.organizationBranchString(this.checkinLocation.organizationBranchId),
                    value: this.checkinLocation.organizationBranchId
                }
            },
            set(obj) {
                this.checkinLocation.organizationBranchId = obj.value
                this.loadEmployee();
            }
        },

        selectedEmployee: {
            get() {
                return {
                    label: this.employeeString(this.checkinLocation.employeeId),
                    value: this.checkinLocation.employeeId
                }
            },
            set(obj) {
                this.checkinLocation.employeeId = obj.value
                this.loadEmployee();
            }
        },
        google: gmapApi,
    },
    methods: {
        getLocationEmployee(item) {
            let fullName = this.$route.query.fullName;
            this.checkinLocation = item
            this.checkinLocation.fullName = fullName
            let interval = setInterval(function () {
                if (document.getElementsByClassName('active').length > 0) document.getElementsByClassName('active')[0].classList.remove('active');
                // document.getElementsByClassName(`listEmployeeMap_${item.id}`)[0].parentElement.classList.add("active");
            }, 100)
            setTimeout(function () {
                clearInterval(interval)
            }, 200)
            this.isUpdate = true;
            this.overtimeStatusModel = {value: item.status};
            this.center = {
                lat: Number(item.latitude),
                lng: Number(item.longitude),
            }
            this.canUpdate = item.status === 0;
            if (item.status === 3) {
                this.checkInLocationStatusOptions = [
                    {value: 0, label: 'Chờ'},
                    {value: 1, label: 'Đã duyệt'},
                    {value: 2, label: 'Từ chối'},
                    {value: 3, label: 'Hủy bỏ'}
                ]
            }
        },
        searchEmployeeData: function () {
            this.addressOptions = this.employeeDataApru;
            let query = this.search.toLowerCase();
            if (query !== '') {
                this.addressOptions = this.addressOptions.filter(
                    (item) =>
                        (item.fullAddress !== null && item.fullAddress.toLowerCase().includes(query)) ||
                        (item.name !== null && item.name.toLowerCase().includes(query))
                );
            }
        },
        addMarker(event) {
            this.locationMarker = {
                lat: event.latLng.lat(),
                lng: event.latLng.lng(),
            };
        },
        updateTimeSpan(setting, hour, type) {
            setting[type] = hour.value;
            setting[`${type}String`] = hour.label;
        },
        saveChanges: function () {
            if (this.checkinLocation.status === 0) {
                return this.$vs.notify({
                    text: 'Bạn vui lòng chuyển trạng thái đơn đăng ký',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            }
            this.$vs.loading();
            this.$crm.put(`employee-location-checkin/approve?id=${this.checkinLocation.id}`, this.checkinLocation).then(() => {
                this.$vs.loading.close();
                this.isUpdate = true;
                this.$router.push('/user/remote-timekeeping')
                return this.$vs.notify({
                    text: 'Cập nhật đơn đăng ký làm việc từ xa thành công',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'success',
                })
            }).catch((err) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: err.response.data.message || 'Cập nhật đơn đăng ký làm việc từ xa thất bại',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                })
            })
        },
        employeeString(id) {
            let employee = this.employeeOptions.find(x => x.value === id);
            return (employee && employee.label) || 'Chưa xác định';
        },
        organizationBranchString(id) {
            let organizationBranch = this.organizationBranchOptions.find(x => x.value === id);
            return (organizationBranch && organizationBranch.label) || 'Chưa xác định';
        },
        initScreen() {
            let id = this.$route.query.id;
            let employeeId = this.$route.query.employeeId;
            if (employeeId && id) this.findDetailRegis(id, employeeId);
        },
        findDetailRegis: function (id, employeeId) {
            this.$crm.get(`employee-location-checkin/find-by-id?id=${id}&employeeId=${employeeId}`).then((res) => {
                this.addressOptions = res.data
                this.employeeDataApru = this.addressOptions
                this.addressOptions[0].isUser = true
                this.checkinLocation = this.addressOptions[0]
                this.isUpdate = true;
                this.overtimeStatusModel = {value: this.checkinLocation.status};
                this.canUpdate = this.checkinLocation.status === 0;
                if (this.checkinLocation.status === 3) {
                    this.checkInLocationStatusOptions = [
                        {value: 0, label: 'Chờ'},
                        {value: 1, label: 'Đã duyệt'},
                        {value: 2, label: 'Từ chối'},
                        {value: 3, label: 'Hủy bỏ'}
                    ]
                }
                let k = this.checkinLocation.id
                if (k) {
                    let interval = setInterval(function () {
                        if (document.getElementsByClassName('active').length > 0) document.getElementsByClassName('active')[0].classList.remove('active');
                        // document.getElementsByClassName(`listEmployeeMap_${k}`)[0].parentElement.classList.add("active");
                    }, 100)
                    setTimeout(function () {
                        clearInterval(interval)
                    }, 200)
                }
                this.getLocationEmployee(this.checkinLocation);
            })
        },
    },
    async created() {
        let check = false;
        this.$eventBus.$on("notify-detail-checkinLocation", ($event) => {
            if ($event) this.initScreen();
            check = true;
        })
        if (!check) this.initScreen();
    }
}
</script>

<style scoped>
.fsz {
    font-size: 21px;
}

.listEmployeeDiv {
    border-bottom: solid 1px #ccc
}

@media only screen and (min-width: 1366px) {
    .scroll {
        max-height: 45rem;
        overflow: auto
    }
}

@media only screen and (min-width: 1920px) {
    .scroll {
        max-height: 45rem;
        overflow: auto
    }
}

@media only screen and (min-width: 2160px) {
    .scroll {
        max-height: 51rem;
        overflow: auto
    }
}

@media only screen and (min-width: 2560px) {
    .scroll {
        max-height: 65rem;
        overflow: auto
    }
}

@media only screen and (min-width: 3840px) {
    .scroll {
        max-height: 87rem;
        overflow: auto
    }
}

.MapPinIcon {
    float: left;
    margin-top: 15px;
    margin-right: 10px;
    margin-left: 10px;
}

.active {
    color: red !important;
}

</style>
